import React from 'react'
import { MdDeleteForever } from 'react-icons/md'
import { Checkbox, SimpleInputLabel, SimpleLabledInput } from '../../components';
import KeyValueFields from './KeyValueFields';


function CreateFieldWrapper({ position, field, setFields, disableEdit = false, allowPartialEdit = false }) {

    const typesWithKeyValue = ['radio', 'checkbox'];

    const transformName = (name) => name
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/ /g, "_")
        .toLowerCase();

    const updateField = (newField) => {
        setFields(oldfields => {
            const newFields = [...oldfields];
            newFields[position - 1] = newField;
            return newFields;
        })
    }

    const toggleFieldDetailsExpansion = () => {
        field.isExpanded = !field.isExpanded;
        updateField(field)
    }

    const updatePrompt = (e) => {
        let inputValue = e.target.value;
        if (inputValue == "") {
            delete field.prompt;
        }
        else {

            //TODO handle alteration
            field.prompt = inputValue;
        }
        updateField(field)

        if(allowPartialEdit) return;
        
        updateFieldName(inputValue);
    }

    const updateFieldName = (name) => {
        if (name == "") {
            delete field.name;
        }
        else {
            field.name = transformName(name)
        }
        updateField(field)
    }

    const handleRequiredChange = (e) => {
        field.validations.isRequired = e.target.checked;
        updateField(field);
    }

    const handleReadOnlyChange = (e) => {
        field.validations.isReadOnly = e.target.checked;
        updateField(field);
    }


    const deleteField = () => {
        if (disableEdit || allowPartialEdit) return;
        setFields(oldfields => [...oldfields.filter(f => f.id != field.id)]);
    }



    return (
        <div className=' rounded-md  my-4  overflow-hidden border-slate-100 border'>

            <div className=' flex bg-slate-100 items-center p-2'>

                <div className='flex items-center gap-4 flex-1' onClick={toggleFieldDetailsExpansion} >
                    <span className=' bg-green-200 rounded-full w-8 h-8 flex justify-center items-center font-semibold '>
                        {position}
                    </span>
                    {/* <h4 className=' font-[500]'>{field.prompt  ?? field.type}</h4> */}
                    <h4 className=' font-[500]'>{field.prompt ? `${field.prompt} (${field.type})` : field.type}</h4>
                </div>

                <div onClick={deleteField}>
                    <MdDeleteForever size={20} color='#991919' />
                </div>
            </div>

            <div className={`${field.isExpanded ? 'block' : 'hidden'} transition p-4 `}>
                <div className=' flex flex-col gap-5'>

                    <SimpleLabledInput label="Prompt" name="lable" type="text" placeholder="" value={field.prompt} onChange={updatePrompt} disabled={disableEdit} />

                    <SimpleLabledInput disabled={disableEdit || allowPartialEdit} label="Field Name(Unique)" name="field_name" type="text"
                        placeholder="" value={field.name} onChange={(e) => updateFieldName(e.target.value)} />


                    {typesWithKeyValue.includes(field.key) && <KeyValueFields field={field} setFields={setFields} />}
                    <div>
                        <SimpleInputLabel>Settings</SimpleInputLabel>
                        <div className='flex gap-4 p-3'>
                            <Checkbox disabled={disableEdit} label="Required" onChange={handleRequiredChange}></Checkbox>
                            <Checkbox disabled={disableEdit} label="ReadOnly" onChange={handleReadOnlyChange}></Checkbox>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default CreateFieldWrapper